import {takenOverCandidateIds} from '@/utils/placementTakeover';

const candidates = {
    firestorePath: '/candidates',
    firestoreRefType: 'collection',
    moduleName: 'candidates',
    statePropName: 'candidates',
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: '%convertTimestamp%',
            updated_at: '%convertTimestamp%',
            availableDate: '%convertTimestamp%',
            bsnUpdatedAt: '%convertTimestamp%'
        },
        addedHook: (updateStore, doc) => {
            doc.age = doc.birthdate ? moment().diff(doc.birthdate, 'years') : null;
            updateStore(doc);
        },
        modifiedHook: (updateStore, doc) => {
            doc.age = doc.birthdate ? moment().diff(doc.birthdate, 'years') : null;
            updateStore(doc);
        }
    },
    state: {
        shifts: ['Dagdienst', 'Versch. dagdienst', 'Nachtdienst', '2 ploegen', '3 ploegen', '4 ploegen', '5 ploegen', 'Vakantiekracht'],
        transports: ['Fiets','Elektrische  fiets', 'Brommer', 'Auto', 'OV kaart'],
        drivingLicenses: ['Geen','AM','A1', 'B', 'C', 'CE','T'],
        retirements: ['Geen pensioen', 'Basispensioen', 'Pluspensioen'],
        language: ['Nederlands', 'Engels']
    },
    getters: {
        getCandidates: (state) => {
            return _.orderBy(state.candidates, ['firstName', 'lastName']);

        },
        getCandidate: (state) => (id) => {
            return state.candidates[id];
        },
        getCandidatesByCreated_at: (state) => {
            return _.chain(state.candidates)
                .filter(candidate => candidate.created_at != null)
                .orderBy(['created_at'])
                .value();
        },
        checkCandidate: (state) => (firstName, lastName) => {
            let candidates = _.toArray(state.candidates);
            let findCandidate = _.find(candidates, {
                'firstName': firstName,
                'lastName': lastName
            });
            return findCandidate;
        },


        getStandardFormChoices: (state) => (choice) => {
            return state[choice];
        },
        getCandidateFullName: (state) => {
            let candidates = _.toArray(state.candidates);
            return _.map(candidates, function (candidate) {
                return {id: candidate.id, fullName: candidate.firstName + ' ' + candidate.lastName};
            });
        },
        getAvailableCandidatesPerCustomer: (state, getters, rootState, rootGetters) => (id) => {
            let placements = rootGetters['placements/getPlacements'];
            let getCandidates = _.toArray(state.candidates);
            let candidates = _.filter(getCandidates, {'blacklisted': false});

            let filteredPlacements = _.filter(placements, {'endDate': '', 'customerId': id});
            let removedCandidates = [];

            if (filteredPlacements.length === 0) {
                return candidates;
            } else {
                for (let p = 0; p < filteredPlacements.length; p++) {
                    removedCandidates = _.remove(candidates, {
                        id: filteredPlacements[p].candidateId
                    });
                }
            }
            return _.difference(candidates, removedCandidates);
        },
        getExperiences: (state) => {
            let candidates = _.toArray(state.candidates);
            let shifts = _.map(candidates, 'experiences');
            let merged = [].concat.apply([], shifts);
            return _.uniq(merged).sort();
        },
        getSalaryMinMax: (state) => {
            let candidates = _.toArray(state.candidates);
            if (!candidates.length) {
                return [0, 1000];
            }
            let salaryMin = Math.min(..._.map(candidates, 'salaryMin'));
            let salaryMax = Math.max(..._.map(candidates, 'salaryMax'));
            return [salaryMin, salaryMax];
        },
        getSalaryMin: (state) => {
            let candidates = _.toArray(state.candidates);
            if (!candidates.length) {
                return 0;
            }
             let salaryMin = Math.max(
                ..._.filter(_.map(candidates, c => c.salaryMin), v => v !== undefined)
            );
             return parseFloat(salaryMin);
        },
        getLastMonthCandidates: (state) => {
            let candidates = _.toArray(state.candidates);
            let thisMonth = _.filter(candidates, function (candidate) {
                let currentDate = moment(new Date()).format('MM-YYYY');
                let candidateDate = moment(candidate.created_at).format('MM-YYYY');
                if (currentDate === candidateDate) {
                    return candidate;
                }
            });
            return thisMonth.length;
        },
        getStoppedCandidates: (state, getters, rootState, rootGetters) => (includeBlacklist, fromDate = new Date(), toDate = new Date()) => {
            // end temp dates
            const blacklist = includeBlacklist ? [] : rootGetters['blacklist/getBlacklist'];
            const candidates = _.toArray(state.candidates).filter(candidate => {

                const whiteListed = blacklist.findIndex(blackListedCandidate => blackListedCandidate.candidateId === candidate.id) === -1;
                // If blacklisted => we dont need it, so return it already
                if (!whiteListed) {
                    return false;
                }

                // Now filter all placements to find the ones that ended within the to-from date
                const placementsOfCandidate = rootGetters['placements/getCandidatePlacements'](candidate.id);
                let endDates = [];
                let activePlacement;
                let endedPlacementsOfCandidate = placementsOfCandidate.filter(placement => {
                    if (!placement.endDate || moment(placement.endDate, 'YYYY-MM-DD').endOf('day').isSameOrAfter(toDate)) {
                        activePlacement = placement;
                    }
                    return placement.endDate && moment(placement.endDate, 'YYYY-MM-DD').isBefore(toDate) && moment(placement.endDate, 'YYYY-MM-DD').isAfter(fromDate);
                });
                endDates = endedPlacementsOfCandidate.map(endedPlacement => {
                    return moment(endedPlacement.endDate, 'YYYY-MM-DD').endOf('day').toDate()
                })
                if (activePlacement) {
                    return false;
                } else {
                    // If any ended placements return candidate
                    // If no ended placements, dont return candidate
                    endDates.sort(sortDateWithMoment);
                    candidate.quittedDate = _.first(endDates);
                    return endedPlacementsOfCandidate.length > 0;
                }
            });
            return candidates;
        },
        getSickCandidates: (state, getters) => {
            return _.filter(getters.getCandidates, ['sick', true]).length;
        },
        getCandidatesWithPlacement: (state, getters, rootState, rootGetters) => {
            let candidates = _.toArray(state.candidates);
            let placements = rootGetters['placements/getPlacements'];

            candidates = candidates.map(candidate => {
                let filteredPlacements = _.filter(placements, (placement) => {
                    // if(placement.endDate) {
                    //   console.log(moment(placement.endDate, 'YYYY-MM-DD').endOf('day').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY'),moment().isBefore(moment(placement.endDate, 'YYYY-MM-DD').endOf('day')) );
                    // }
                    if (placement.candidateId === candidate.id) {
                        return !placement.endDate ||
                            (placement.endDate &&
                                moment().isSameOrBefore(moment(placement.endDate, 'YYYY-MM-DD').endOf('day')) &&
                                moment().isSameOrAfter(moment(placement.startDate, 'YYYY-MM-DD').startOf('day')));
                    }
                });
                candidate.activePlacement = !!filteredPlacements.length;
                return candidate;
            });
            return candidates;
        },
        getCandidatesWithPlacementNowOrInFuture: (state, getters, rootState, rootGetters) => {
            let candidates = _.toArray(state.candidates);
            let placements = rootGetters['placements/getPlacements'];
            const takenOver = takenOverCandidateIds(placements);

            candidates = candidates.map(candidate => {
                let filteredPlacements = _.filter(placements, (placement) => {
                    if (placement.candidateId === candidate.id) {
                        return (!placement.endDate || moment(placement.endDate, 'YYYY-MM-DD').isSameOrAfter(moment().startOf('day')));
                    }
                });
                candidate.activePlacement = !!filteredPlacements.length;
                candidate.takenOver = takenOver.has(candidate.id);
                candidate.activePlacementData = _.map(filteredPlacements, placement => {
                    return {
                        ...placement,
                        customer: rootGetters['customers/getCustomer'](placement.customerId)
                    }
                })

                return candidate;
            });
            return candidates;
        }
    },
    mutations: {},
    actions: {},
    sync: {
        fillables: [], // array of  keys
        guard: ['created_by'] // array of keys
    }
};

const sortDateWithMoment = function (date1, date2) {
    // This is a comparison function that will result in dates being sorted in
    // DESCENDING order.
    if (moment(date1).isAfter(moment(date2))) return -1;
    if (moment(date1).isBefore(moment(date2))) return 1;
    return 0;
};

export default candidates;